import { createAction, props } from '@ngrx/store';
import { AuthenticationForm, User, Authentication } from '@core/models'

export const AUTH_UPDATE_VIEW = createAction('[Auth] Update IView');
export const AUTH_RESET = createAction('[Auth] Reset');
export const AUTH_RESET_PASSWORD = createAction('[Auth] Reset Password')

export const AUTH_SING_UP = createAction('[Auth] Sign up');
export const AUTH_SING_UP_SUCCESS = createAction('[Auth] Sign Up Success', props<{ registered: boolean }>());
export const AUTH_SING_UP_FAILURE = createAction('[Auth] Sign Up Failure', props<{ error: string }>());
export const AUTH_RESET_REGISTRATION = createAction('[Auth] Reset Registration Status');

export const AUTH_LOG_IN = createAction('[Auth] Log In');
export const AUTH_UPDATE_FORM = createAction('[Auth] Update Form', props<{ authForm: AuthenticationForm  }>())
export const AUTH_FIND_SUCCESS = createAction('[Auth] Find Success', props<{ auth: Authentication }>());
export const AUTH_FAILED = createAction('[Auth] Failed', props<{ error: string }>());
export const AUTH_UPDATE_LOADING = createAction('[Auth] Update Loading', props<{ loading: boolean }>());

export const AUTH_RESET_STATE = createAction('[Auth] Reset State');
export const AUTH_CHANGE_PASSWORD = createAction('[Auth] Change Password',props<{ password: string, token: string }>());
export const AUTH_REFRESH_TOKEN = createAction('[Auth] Refresh Token');
export const AUTH_LOGOUT = createAction('[Auth] Logout');

export const USER_FIND = createAction('[User] Find');
export const USER_FIND_SUCCESS = createAction('[User] Find Success', props<{ user: User }>());
export const USER_FAILED = createAction('[User] Failed', props<{ error: string }>());
export const USER_UPDATE_LOADING = createAction('[User] Update Loading', props<{ loading: boolean }>());
export const USER_UPDATE_FORM = createAction('[User] Update Form', props<{ userForm: User }>());
export const USER_UPDATE = createAction('[User] Update ');
export const USER_UPDATE_COMPLETED = createAction('[User] Update Completed');

export const USER_CLEAR_STATE = createAction('[User] Clear State');

